<template>
    <RefinanceWizard v-bind="$props" />
</template>

<script>

import RefinanceWizard from '../../introxl/refinance/RefinanceWizard.vue';
import { RefinancePropsMixin } from '../../introxl/refinance/mixins/RefinancePropsMixin';

export default {
    mixins: [RefinancePropsMixin],
    components: {
        RefinanceWizard,
    },
}
</script>
